import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, switchMap, map, tap } from 'rxjs/operators';
import { of } from 'rxjs';

import { LanguageService } from '../../services/language.service';
import { UIActions } from './ui.actions';

@Injectable()
export class UIEffects {
  constructor(private actions$: Actions, private languageService: LanguageService) {}

  getLanguageListStart$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UIActions.get_language_list_start),
        switchMap(() => {
          return this.languageService.getLanguageList().pipe(
            map(data => UIActions.get_language_list_success({ languageList: data })),
            catchError(error => of(UIActions.get_language_list_fail({ error: error })))
          );
        })
      ),
    { dispatch: true }
  );

  getLanguageListFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UIActions.get_language_list_fail),
        tap(data => {
          throw data.error;
        })
      ),
    { dispatch: false }
  );
}
